import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardAdmin  {
  private auth = inject(AuthService);
  private router = inject(Router);


  canActivate(): boolean | UrlTree {
    return this.auth.isAdmin || this.router.parseUrl('/notfound');
  }

}
